import React from 'react';
import cn from 'classnames';
import { ID } from '@app/types';
import Header from '@components/Header';
import { useDispatch, useSelector } from 'react-redux';
import { selectGroupShareStatus } from '@reducers/data/shareStatuses/groups';
import { openModal, selectActiveModalType } from '@actions/ui';
import styles from './Header.module.scss';

export default function ShareGroupBtn({ groupID }: { groupID: ID }) {
  const dispatch = useDispatch();
  const groupShareStatus = useSelector(selectGroupShareStatus(groupID));
  const activeModalType = useSelector(selectActiveModalType);

  return (
    <Header.Action
      className={cn(styles.btn, 'btn-blue', activeModalType == 'shareContact' && 'btn-blue-active')}
      title={groupShareStatus.isShared ? 'Shared' : 'Share'}
      onClick={() => dispatch(openModal('shareGroup'))}
      tooltip={false}
      large
      hover
      asButton
    />
  );
}
